import { useQuery } from "@tanstack/react-query";

import type { ModeRegistryEntry } from "../types/api";
import { apiClient } from "../utils/api";

export const modesRegistryQueryKey = ["modes", "registry"] as const;

export function useModesRegistry() {
  return useQuery({
    queryKey: modesRegistryQueryKey,
    queryFn: (): Promise<ModeRegistryEntry[]> => apiClient.getModesRegistry(),
    staleTime: 30 * 60 * 1000,
  });
}

export function modeLabel(
  entry: ModeRegistryEntry | undefined,
  lang: string
): string {
  if (!entry) return "";
  return lang === "ar" ? entry.name_ar : entry.name_en;
}
